import { Service } from '../../../../../../redux/services/types';
import { useDeleteService } from './useDeleteService';

export const useDeleteWithConfirmation = (service: Service) => {
  const { deleteMasterService, isSuccess } = useDeleteService();

  const deleteWithConfirmation = () => {
    if (confirmDeletion()) {
      deleteMasterService(service._id);
    }
  };

  return { deleteWithConfirmation, isSuccess };
};

function confirmDeletion() {
  return window.confirm('Are you sure you want to delete this service?');
}
